import {Button} from 'antd'
import openWindow from '@/script/openWindow.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default function PropertiesPaneButtonCompleteFmCode(props) {
    const map = useMapContext()

    const onClick = () => {
        const {prjId, sVer} = map.data
        const {name, textProp} = map.BizNode.FA

        const {
            pkid: dpId,
            [textProp]: dpName,
        } = map.root.data

        openWindow(
            '/Ai',

            {
                bizMap: {dpId, dpName},
                prjId,
                scene: 'COMPLETION_FA',
                sVer,
                title: `${name}: ${dpName}`,
            })
    }

    return (
        <Button
            onClick={onClick}
            {...props}
        >
            AI补全功能域代码
        </Button>
    )
}
